// extracted by mini-css-extract-plugin
export default {"btn_style":"styles_btn_style__P3J1h","select_custom_width":"styles_select_custom_width__4gQ52"};